module.exports = __webpack_public_path__ + "7f106765647ac527b213f653b0464572.pdf";